// @flow @jsx h

import { h } from 'preact'
import { Explanation } from './Explanation'
import { Box } from './common/Box'
import type { Question } from '../../types'

type Props = {
  currentQuestion: Question,
  isCorrect: boolean,
  onNextClick: () => void
}

const ExplanationView = ({
  currentQuestion,
  isCorrect,
  onNextClick
}: Props) => {
  return (
    <Box appearLate>
      <Explanation
        wasCorrect={isCorrect}
        explanation={currentQuestion.explanation}
        onNextClick={onNextClick}
      />
    </Box>
  )
}

export { ExplanationView }



// WEBPACK FOOTER //
// ./src/v1/components/Foreground/ExplanationView.js